export default __webpack_public_path__ + "static/media/FiraSansExtraCondensed-Regular.ddf22cb0.ttf";